{
  "title": "อนุญาตให้เข้าถึงตำแหน่งของคุณหรือไม่",
  "body": "การอนุญาตให้เข้าถึงตำแหน่งของคุณช่วยให้เรายืนยันได้ว่าคุณมาถึงสถานที่เพื่อเช็กอินแล้ว",
  "disagree": "ไม่อนุญาต",
  "agree": "อนุญาต"
}
